module.exports = __webpack_public_path__ + "static/media/EPICPDF.ef2e2da8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/EPICPDF.svg
// module id = 2624
// module chunks = 0